import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {Card} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import {Link} from 'react-router-dom';

import {GET_CLUBS} from '../../graphql';
import {Club} from '../../interfaces';

import SelectClub from './components/SelectClub';

interface ParsedClub extends Club {
  key: string;
}

interface Properties {
  regionId: String;
}

class SelectClubWrap extends Component<Properties> {
  render() {
    const {regionId} = this.props;
    return (
      <Query query={GET_CLUBS} variables={{regionId}}>
        {({loading, error, data: {clubs}}: any) => {
          if (loading) {
            return <Card loading={loading} />;
          }

          if (error) {
            return `Error! ${error.message}`;
          }

          const dataSource: Array<ParsedClub> = clubs.map((club: Club) => ({
            id: club.id,
            name: club.name,
            key: club.id,
          }));

          const columns: Array<ColumnProps<ParsedClub>> = [
            {
              title: 'Club',
              dataIndex: 'id',
              key: 'id',
              render: (id: String, record: ParsedClub) => <Link to={`/memberships/${regionId}/${id}`}>{record.name}</Link>,
            },
          ];

          return <SelectClub dataSource={dataSource} columns={columns} />;
        }}
      </Query>
    );
  }
}

export default SelectClubWrap;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/SelectClub/SelectClubWrap.tsx